import { Box, Button, Grow, Typography } from "@mui/material";
import { useEffect, useRef } from "react";


interface Props {
  checked: boolean;
  handleClose: Function;
  text: string[];
}


export default function ValidationErrors(props: Props) {
  const { checked, handleClose, text } = props;
  const buttonRef = useRef<HTMLButtonElement>(null);
  const lastFocusedElement = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (checked && buttonRef.current) {
      lastFocusedElement.current = document.activeElement as HTMLElement;

      // Kleiner Timeout, um sicherzustellen, dass das Modal vollständig gerendert ist
      const timeoutId = setTimeout(() => {
        buttonRef.current?.focus();
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [checked]);

  return (
    <Box sx={{
      width: "30%",
      minWidth: "300px",
      maxWidth: "90%",
      position: "absolute",
      top: "50%",
      left: "50%",
      backgroundColor: "white",
      transform: "translate(-50%, -50%)",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      gap: 2,
      padding: 4,
      textAlign: "center",
    }}>
      <Grow style={{ borderRadius: 16 }} in={checked}>
        <Box>
          {text.map((t, index) => (
            <Typography key={index} fontSize={15} fontWeight={"bold"}>
              {t}
            </Typography>
          ))}
          <Button
            ref={buttonRef}
            onClick={(event) => {
              handleClose(event)
              if (lastFocusedElement.current) {
                lastFocusedElement.current.focus();
              }
            }}
            sx={{
              flexGrow: 1,
              borderRadius: "26px",
              color: "#072D26",
              fontWeight: "bold",
              border: "2px solid #C0D904",
              height: "51px",
              paddingLeft: "50px",
              paddingRight: "50px",
              "&:hover": { background: "#c0d904" }
            }}>
            Fortfahren
          </Button>
        </Box>
      </Grow>
    </Box>

  )

}